export const fetchData = async (url) => {
  return await fetch(url);
};
